/**
 * TestEnvBadge
 *
 * Small "TEST" chip shown wherever the central login surfaces a tenant that
 * lives in the test environment (beta-* tenants served by the test SWA/DB).
 * Makes it unmistakable that the user is signing in to a non-production copy.
 *
 * Uses the semantic warn colour (carries meaning — not part of the accent
 * budget), per the branding rules.
 */
export default function TestEnvBadge({ style }) {
  return (
    <span
      style={{
        display: 'inline-block',
        marginTop: 8,
        padding: '2px 8px',
        borderRadius: 6,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        fontFamily: 'var(--font-mono)',
        color: 'var(--warn)',
        background: 'var(--warn-bg, rgba(245,158,11,0.08))',
        border: '1px solid rgba(245,158,11,0.3)',
        ...style,
      }}
    >
      Test
    </span>
  );
}
